// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { projectSchema } from '@/project/api/types';
import { z } from 'zod';

const projectResponseSchema = z
  .object({ data: projectSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, project: data }));

type ProjectResponse = z.infer<typeof projectResponseSchema>;

/**
 * Requests a projects from the remote API.
 *
 * @param key - The key of the project to request.
 */
export async function getProject(key: string): Promise<ProjectResponse> {
  const url = `/v1/project/${key}`;
  const response = await api.get(url);

  return parseResponse(projectResponseSchema, response.data, {
    schemaName: 'Project',
    endpoint: url,
  });
}
